import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcRefreshBlack = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M10 10L14 6L10 2",
		stroke: "black"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M18.0622 9.5C18.8552 10.8736 19.1583 12.4759 18.9217 14.0443C18.685 15.6127 17.9228 17.0542 16.7598 18.1327C15.5967 19.2112 14.1019 19.8628 12.5202 19.9806C10.9384 20.0985 9.36351 19.6757 8.05349 18.7814C6.74347 17.8872 5.77598 16.5746 5.30953 15.0586C4.84308 13.5426 4.90532 11.9131 5.48606 10.4371C6.06679 8.96109 7.13158 7.72607 8.506 6.93436C9.88042 6.14265 11.483 5.84119 13.0511 6.07937",
		stroke: "black",
		strokeLinecap: "round"
	})]
});
export default SvgIcRefreshBlack;
